// import { Observable } from "apollo-link";
import { onError } from "apollo-link-error";
import { ApolloClient } from "apollo-client";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createUploadLink } from "apollo-upload-client";

// const catchError = ({ forward, operation }) => {
// 	return new Observable(observer => {
// 		let subscription;
// 		try {
// 			subscription = forward(operation).subscribe({
// 				next: result => {
// 					if (result.errors) {
// 						onError({
// 							operation,
// 							response: result,
// 							graphQLErrors: result.errors
// 						});
// 					}
// 					observer.next(result);
// 				},
// 				error: error => {
// 					onError({
// 						operation,
// 						networkError: error,
// 						//Network errors can return GraphQL errors on for example a 403
// 						graphQLErrors: error.result && error.result.errors
// 					});
// 				},
// 				complete: observer.complete.bind(observer)
// 			});
// 		} catch (error) {
// 			onError({ networkError: error, operation });
// 		}

// 		return () => {
// 			if (subscription) subscription.unsubscribe();
// 		};
// 	});
// };

const authLink = setContext((_, { headers }) => {
	// get the authentication token from local storage if it exists
	const token = localStorage.getItem("accessToken");
	// return the headers to the context so httpLink can read them
	return {
		headers: {
			...headers,
			authorization: token ? `Bearer ${token}` : ""
		}
	};
});

// Error Handling
const errorLink = onError(errors => {
	const { graphQLErrors, networkError } = errors;
	if (graphQLErrors) graphQLErrors.map(({ message, locations, path }) => console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`));
	if (networkError) console.log(`[Network error]: ${networkError}`);
	if (networkError && networkError.statusCode === 403) {
		localStorage.removeItem("userInfo");
		localStorage.removeItem("accessToken");
		location.reload();
	}

	// return catchError(errors);
});

// const domain = "https://comaylink.com";
const domain = process.env.VUE_APP_GRAPHQL_DEFAULT_ENDPOINT;

const defaultOptions = {
	watchQuery: {
		fetchPolicy: "no-cache",
		errorPolicy: "ignore"
	},
	query: {
		fetchPolicy: "no-cache",
		errorPolicy: "all"
	}
};

export default function createGraphqlClient(uri) {
	if (uri) {
		uri = "/" + uri;
	}

	const httpLink = createUploadLink({
		uri: `${domain}/graphql${uri}`
	});

	return new ApolloClient({
		connectToDevTools: true,

		// Provide the URL to the API server.
		link: errorLink.concat(authLink.concat(httpLink)),
		// Using a cache for blazingly
		// fast subsequent queries.
		cache: new InMemoryCache(),
		defaultOptions: defaultOptions
	});
}
